import {
  Component,
  ViewChild,
  OnInit
} from '@angular/core';
import {
  Angular2Csv
} from 'angular2-csv/Angular2-csv';
import {
  ExportsService
} from "../../../../injections/exports.service";
import * as moment from 'moment';

@Component({
  selector: 'export-cleaners',
  templateUrl: '../../templates/partials/cleaners-exports.html'
})
export class ExportCleanersComponent implements OnInit{

  @ViewChild('dateFrom') dateFrom;
  @ViewChild('dateSince') dateSince;
  public type: string;

  public headerData: object = {
    name: "CIUDAD",
    nombre: "NOMBRE",
    mangopay_user_id: "ID USUARIO MANGOPAY",
    mangopay_wallet_id: "ID WALLET MANGOPAY",
    document: "DNI/NIE",
    document_validity: "FECHA DE VALIDEZ",
    direccion: "DIRECCIÓN",
    email: "EMAIL",
    phone: "TELÉFONO",
    iban: "IBAN",
    notes: "NOTAS"
  }

  public buttonDisabled = true;

  constructor(private exportsService: ExportsService) {}

  public closeSibiling(event){
    //console.log(event);
    if(event == "desde"){
        this.dateSince.opened = false;
    }else if(event == "hasta"){
         this.dateFrom.opened = false;
    }
 }

  public exportCleaners() {
    this.buttonDisabled = true;
    this.checkType();
  }

  public onChangeSelect() {
    this.buttonDisabled = false;
  }
  public checkType() {
      switch(this.type) {
          case "bookings": this.getBookings();
          break;

          case "userV": this.getUserValuations();
          break;

          case "cleanerV": this.getCleanerValuations();
          break;

          case "cancellations": this.getCancellations();
          break;

          case "cleanerRanking": this.getCleanerRanking();
          break;

          case "leads": this.getLeads();
          break;

      }
  }

  private getBookings() {
    var dateIni = (this.dateFrom.formatDate != null) ? moment(this.dateFrom.formatDate,"DD/MM/YYYY").format("YYYY-MM-DD") : '';
    var dateEnd = (this.dateSince.formatDate != null) ? moment(this.dateSince.formatDate,"DD/MM/YYYY").format("YYYY-MM-DD") : '';
    this.exportsService.exportBookings(dateIni, dateEnd).subscribe(result => {
        this.parseCSV(dateIni, dateEnd, result, "Reservas");
    });
  }

  private getUserValuations() {
    var dateIni = (this.dateFrom.formatDate != null) ? moment(this.dateFrom.formatDate,"DD/MM/YYYY").format("YYYY-MM-DD") : '';
    var dateEnd = (this.dateSince.formatDate != null) ? moment(this.dateSince.formatDate,"DD/MM/YYYY").format("YYYY-MM-DD") : '';
    this.exportsService.exportUserValuations(dateIni, dateEnd).subscribe(result => {
        this.parseCSV(dateIni, dateEnd, result, "Valoraciones_Usuario");
    });
  }

  private getCleanerValuations() {
    var dateIni = (this.dateFrom.formatDate != null) ? moment(this.dateFrom.formatDate,"DD/MM/YYYY").format("YYYY-MM-DD") : '';
    var dateEnd = (this.dateSince.formatDate != null) ? moment(this.dateSince.formatDate,"DD/MM/YYYY").format("YYYY-MM-DD") : '';
    this.exportsService.exportCleanerValuations(dateIni, dateEnd).subscribe( result => {
        this.parseCSV(dateIni, dateEnd, result, "Valoraciones_Cleaner");
    })
  }

  private getCancellations() {
    var dateIni = (this.dateFrom.formatDate != null) ? moment(this.dateFrom.formatDate,"DD/MM/YYYY").format("YYYY-MM-DD") : '';
    var dateEnd = (this.dateSince.formatDate != null) ? moment(this.dateSince.formatDate,"DD/MM/YYYY").format("YYYY-MM-DD") : '';
    this.exportsService.exportByCancellations(dateIni, dateEnd).subscribe( result => {
        this.parseCSV(dateIni, dateEnd, result, "Cancelaciones");
    })
  }

  private getLeads() {
    var dateIni = (this.dateFrom.formatDate != null) ? moment(this.dateFrom.formatDate,"DD/MM/YYYY").format("YYYY-MM-DD") : '';
    var dateEnd = (this.dateSince.formatDate != null) ? moment(this.dateSince.formatDate,"DD/MM/YYYY").format("YYYY-MM-DD") : '';
    this.exportsService.exportLeads(dateIni, dateEnd).subscribe( result => {
        this.parseCSV(dateIni, dateEnd, result, "Leads");
    })
  }

  private getCleanerRanking() {
    var dateIni = (this.dateFrom.formatDate != null) ? moment(this.dateFrom.formatDate,"DD/MM/YYYY").format("YYYY-MM-DD") : '';
    var dateEnd = (this.dateSince.formatDate != null) ? moment(this.dateSince.formatDate,"DD/MM/YYYY").format("YYYY-MM-DD") : '';
    this.exportsService.exportCleanerRanking(dateIni, dateEnd).subscribe( result => {
        this.parseCSV(dateIni, dateEnd, result, "Ranking_Cleaners");
    })
  }

  private parseCSV(dateIni, dateEnd, url, type) {
    window.open(url,'_blank');
    this.buttonDisabled = false;
  }

  ngOnInit() {
    this.dateFrom.dt = moment().subtract(7, 'days').toDate();
    this.dateSince.dt = moment().add(7, 'days').toDate();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/exports/components/dummy/cleaners-exports.component.ts